import React from "react";
import { COLOUR_PAIRINGS } from "../data/site";

const colourHex = (slug, colourways) => colourways.find((c) => c.slug === slug)?.hex || "#F4F6F8";

const ColourMatching = ({ colourways = [] }) => {
  return (
    <section className="container-x py-20 md:py-28" data-testid="colour-matching">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12">
        <div className="md:col-span-7">
          <p className="overline mb-4">Colour Matching</p>
          <h2 className="font-display uppercase text-4xl md:text-6xl tracking-tightest font-bold leading-[0.95]">
            Match the boots.
            <br />
            Match the kit.
            <br />
            <span className="text-mute">Finish the look.</span>
          </h2>
        </div>
        <div className="md:col-span-5 flex md:items-end">
          <p className="text-mute max-w-md leading-relaxed">
            Pritch colourways are designed for the way footballers actually buy kit — by matching
            boots, socks, sleeves and matchday colours.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-line border border-line">
        {COLOUR_PAIRINGS.map((p, idx) => (
          <div
            key={p.sock}
            className="bg-white p-6 md:p-8 flex items-center gap-5"
            data-testid={`pairing-${p.sock}`}
          >
            <div
              className="w-20 h-20 md:w-24 md:h-24 border border-line flex-shrink-0"
              style={{ backgroundColor: colourHex(p.sock, colourways) }}
            />
            <div>
              <p className="mono text-xs text-mute">0{idx + 1} · Pairing</p>
              <p className="font-display text-lg uppercase tracking-tight mt-1">
                {colourways.find((c) => c.slug === p.sock)?.name || p.sock}
              </p>
              <p className="text-xs text-mute mt-1.5">Boot · {p.boot}</p>
              <p className="text-xs text-mute">Kit · {p.kit}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ColourMatching;
